import RowSelectionCheckbox from './row-selection-checkbox';

const useRowSelection = (customRowSelection) => {
  const { selectedRowKeys, onChange } = customRowSelection;

  const customSetSelectedRowKeys = (setRowSelectionCallBack) => {
    if (selectedRowKeys) {
      setRowSelectionCallBack(() => {
        const selectionObj = {};
        for (const key of selectedRowKeys) {
          selectionObj[key] = true;
        }
        return selectionObj;
      });
    }
  };

  const setSelectedRowKeys = (setRowSelectionCallBack) => {
    !selectedRowKeys && setRowSelectionCallBack();
  };

  const customSelectChange = (selectRows) => {
    typeof onChange === 'function' && onChange(selectRows);
  };

  const mergeRowSelectionColumns = (columns) => {
    return [
      customRowSelection && {
        id: 'select',
        header: ({ table }) => (
          <RowSelectionCheckbox
            checked={table.getIsAllRowsSelected()}
            indeterminate={table.getIsSomeRowsSelected()}
            onChange={table.getToggleAllRowsSelectedHandler()}
          />
        ),
        cell: ({ row }) => (
          <RowSelectionCheckbox
            checked={row.getIsSelected()}
            indeterminate={row.getIsSomeSelected()}
            onChange={row.getToggleSelectedHandler()}
          />
        ),
      },
      ...columns,
    ];
  };

  return {
    setSelectedRowKeys,
    customSelectChange,
    customSetSelectedRowKeys,
    mergeRowSelectionColumns,
  };
};

export default useRowSelection;
